export default __webpack_public_path__ + "static/cafe_36085-c62c746188d4b50ee4dac9c3612fac29.png";